/**
 * Public quote-form schemas — one block per section.
 *
 * Each "question" renders as a single-select (`choice`) or text input
 * (`text` / `email` / `tel`). The `key` is what the API receives in the
 * `enquiry` payload, so `area`, `timing`, `location`, `project_type` are
 * common across sections — that lets supplier dashboards filter cleanly.
 */
export const QUOTE_FORMS = {
  probound: {
    label: "ProBound",
    tagline: "Resin Bound Surfacing — get a free quote from your local Approved Installer",
    primary: "#2F5E96",
    secondary: "#300122",
    questions: [
      {
        key: "project_type",
        label: "What type of project are you looking for?",
        type: "choice",
        options: ["New driveway", "Existing driveway overlay", "Patio", "Pathways", "Unsure / need advice"],
      },
      {
        key: "area",
        label: "Approximately how large is the area?",
        type: "choice",
        options: ["Under 25m² (1 Car Driveway)", "25–50m² (2 Car Driveway)", "50–100m² (3-4 Car Driveway)", "100m²+", "Unsure"],
      },
      {
        key: "timing",
        label: "When are you hoping to get the work completed?",
        type: "choice",
        options: ["ASAP", "Within 1 month", "Within 3 months", "Just gathering quotes"],
      },
      {
        key: "needs",
        label: "Would you like:",
        type: "multi",
        options: ["A free quote", "Design inspiration", "Colour options", "Information on guarantees", "Advice on choosing the right installer"],
      },
    ],
  },
  proepoxy: {
    label: "ProEpoxy",
    tagline: "Epoxy Flooring Systems — get a free quote from your local Approved Installer",
    primary: "#7A0B7A",
    secondary: "#300033",
    questions: [
      {
        key: "project_type",
        label: "What type of epoxy floor are you interested in?",
        type: "choice",
        options: ["Metallic marble effect", "Flake floor system", "Garage floor coating", "Commercial / business flooring", "Unsure / need advice"],
      },
      {
        key: "location",
        label: "Where is the project located?",
        type: "choice",
        options: ["Garage", "Kitchen / Living Area", "Commercial premises", "Shop / Salon / Barbershop", "Other"],
      },
      {
        key: "area",
        label: "Approximately how large is the area?",
        type: "choice",
        options: ["Under 20m²", "20–50m²", "50–100m²", "100m²+", "Unsure"],
      },
      {
        key: "timing",
        label: "When are you looking to have the work completed?",
        type: "choice",
        options: ["ASAP", "Within 1 month", "Within 3 months", "Just gathering ideas/quotes"],
      },
      {
        key: "priorities",
        label: "What matters most to you?",
        type: "multi",
        options: ["Appearance / design", "Durability", "Easy maintenance", "Warranty / security", "Price / value"],
      },
    ],
  },
  prodecor: {
    label: "ProDecor",
    tagline: "Decorative Walling & Flooring — get a free quote from your local Approved Installer",
    primary: "#D4A24B",
    secondary: "#2B2101",
    questions: [
      {
        key: "project_type",
        label: "What type of installation are you interested in?",
        type: "choice",
        options: ["Decorative Floor", "Decorative Wall"],
      },
      {
        key: "location",
        label: "Where is the project located?",
        type: "choice",
        options: ["Bathroom / Wetroom", "Kitchen / Living Area", "Commercial premises", "Shop / Salon / Barbershop", "Other"],
      },
      {
        key: "area",
        label: "Approximately how large is the area?",
        type: "choice",
        options: ["Under 20m²", "20–50m²", "50–100m²", "100m²+", "Unsure"],
      },
      {
        key: "timing",
        label: "When are you looking to have the work completed?",
        type: "choice",
        options: ["ASAP", "Within 1 month", "Within 3 months", "Just gathering ideas/quotes"],
      },
      {
        key: "priorities",
        label: "What matters most to you?",
        type: "multi",
        options: ["Appearance / design", "Durability", "Easy maintenance", "Warranty / security", "Price / value"],
      },
    ],
  },
};
